import { render, staticRenderFns } from "./SpaceCardBadges.vue?vue&type=template&id=5d300e98&scoped=true"
import script from "./SpaceCardBadges.vue?vue&type=script&lang=ts"
export * from "./SpaceCardBadges.vue?vue&type=script&lang=ts"
import style0 from "./SpaceCardBadges.vue?vue&type=style&index=0&id=5d300e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d300e98",
  null
  
)

export default component.exports